export default {
  About: () => import("./AboutView.vue"),
  Nofind: () => import("./404View.vue"),
  Home: () => import("./HomeView.vue"),
  GoTo: () => import("./GoToView.vue"),
};
